import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { finalize, map, Observable } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { helper } from 'src/environments/helper';
import { SubcategoriesService } from '../subcategories.service';
import { SubcategoriesAddPayload } from '../subcategories.interface';
import { CategoriesService } from '../../categories/categories.service';
import { Generic } from 'src/app/interfaces/generic.interface';
import { notDefaultValidator } from 'src/app/shared/validators/not-default';

@Component({
    selector: 'app-add-subcategories',
    templateUrl: './add-subcategories.component.html',
    styleUrls: ['./add-subcategories.component.scss']
})
export class AddSubcategoriesComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    categorii$!: Observable<Generic[]>;

    defaultParameter: { name: string; id: number } = {
        name: '--Alegeți--',
        id: -1,
    };

    form: FormGroup = new FormGroup({
        title: new FormControl('', [Validators.required]),
        slug: new FormControl('', [Validators.required]),
        description: new FormControl('', [Validators.required]),
        id_category: new FormControl('', [Validators.required, notDefaultValidator('-1')]),
    });

    constructor(
        private dialogRef: MatDialogRef<AddSubcategoriesComponent>,
        private requestService: SubcategoriesService,
        private categoriesService: CategoriesService,
        private notificationService: NotificationService,
    ) { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    ngOnInit() {
        this.loadCategoriesActive();
    }

    loadCategoriesActive() {
        this.isLoading = true;
        this.categorii$ = this.categoriesService
            .getListActive()
            .pipe(
                map((results: any) => [this.defaultParameter, ...results]),
                finalize(() => (this.isLoading = false))
            );
    }

    submitForm() {
        this.isLoading = true;

        const { title, slug, description, id_category } = this.form
            .value as SubcategoriesAddPayload;
        const payload: SubcategoriesAddPayload = {
            title,
            slug,
            description,
            id_category
        };

        this.requestService
            .storeEntry(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
